// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Disclosure} from '@headlessui/react';
import {fetchSync, Link} from '@shopify/hydrogen';

import {Text, IconClose} from '~/components';
import {availabilityIcon, classNames, shortDate} from '../../lib/hatcherybrain';

export function AvailabilityTable({sku, title}) {
  const {availability} = fetchSync(
    `https://apiv2.hatcherybrain.com/feed/${sku}`,
  ).json();

  const responseDates = Object.keys(availability);

  if (!availability || responseDates.length === 0) {
    return;
  }

  const dates = responseDates.sort((a, b) => {
    const date1 = new Date(a);
    const date2 = new Date(b);
    return date1.getTime() - date2.getTime();
  });

  return (
    <Disclosure key={title} as="div" className="grid w-full gap-2">
      {({open}) => (
        <>
          <Disclosure.Button className="text-left">
            <div className="flex justify-between">
              <Text size="lead" as="h4">
                {title}
              </Text>
              <IconClose
                className={`${
                  open ? '' : 'rotate-[45deg]'
                } transition-transform transform-gpu duration-200`}
              />
            </div>
          </Disclosure.Button>

          <Disclosure.Panel className={'pb-4 pt-2 grid gap-2'}>
            <div className="mt-2 flex flex-col">
              <div className="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle">
                  <div className="shadow-sm ring-1 ring-black ring-opacity-5">
                    <table
                      className="min-w-full border-separate"
                      style={{borderSpacing: 0}}
                    >
                      <thead className="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 
                            bg-opacity-75 py-2 px-5 text-center text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
                          >
                            Date
                          </th>
                          <th
                            scope="col"
                            className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 
                            bg-opacity-75 px-5 py-3.5 text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter "
                          >
                            Availability
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        {dates.map((date, dateIdx) => {
                          const availabilityObject = availability[date];

                          const iconClass = availabilityIcon(
                            availabilityObject.notSexed,
                          );

                          const availabilityStatus =
                            availabilityObject.notSexed;

                          return (
                            <tr
                              key={date}
                              className={`${classNames(
                                availabilityStatus !== 'UNAVAILABLE'
                                  ? 'bg-blue-100'
                                  : 'bg-gray-200',
                              )} `}
                            >
                              <td
                                className={classNames(
                                  dateIdx !== dates.length - 1
                                    ? 'border-b border-gray-200'
                                    : '',
                                  'whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8 text-center  hover:text-indigo-900',
                                )}
                              >
                                <Link to={`/hatch/${date}`}>
                                  {shortDate(date)}
                                </Link>
                              </td>
                              <td
                                className={classNames(
                                  dateIdx !== dates.length - 1
                                    ? 'border-b border-gray-200'
                                    : '',
                                  'whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-center',
                                )}
                              >
                                {iconClass}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Disclosure.Button>
              <div className="flex justify-end">
                <IconClose
                  className={`${
                    open ? '' : 'rotate-[45deg]'
                  } transition-transform transform-gpu duration-200 text-gray-900`}
                />
              </div>
            </Disclosure.Button>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
